"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStyle = exports.getClassName = exports["default"] = exports.Avatar = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Avatar = _interopRequireDefault(require("@mui/material/Avatar"));
var _proptypes = _interopRequireDefault(require("./proptypes"));
var _excluded = ["textColor", "backgroundColor", "imgSrc", "size", "initials", "alt", "children", "className", "style"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var styles = {
  "avatar": "s1oBbR",
  "extraSmall": "-gBU1I",
  "small": "WkWeH-",
  "medium": "fQsmp9",
  "large": "donC68"
};
var getClassName = exports.getClassName = function getClassName(_ref) {
  var className = _ref.className,
    size = _ref.size;
  return (0, _clsx["default"])(className, styles.avatar, styles[size]);
};
var getStyle = exports.getStyle = function getStyle(_ref2) {
  var backgroundColor = _ref2.backgroundColor,
    style = _ref2.style,
    textColor = _ref2.textColor;
  return _objectSpread(_objectSpread(_objectSpread({}, backgroundColor ? {
    '--background-color': backgroundColor
  } : {}), textColor ? {
    '--color': textColor
  } : {}), style);
};
var Avatar = exports.Avatar = function Avatar(_ref3) {
  var textColor = _ref3.textColor,
    backgroundColor = _ref3.backgroundColor,
    imgSrc = _ref3.imgSrc,
    size = _ref3.size,
    initials = _ref3.initials,
    alt = _ref3.alt,
    children = _ref3.children,
    className = _ref3.className,
    style = _ref3.style,
    props = _objectWithoutProperties(_ref3, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Avatar["default"], _extends({
    size: size,
    src: imgSrc,
    className: getClassName({
      className: className,
      size: size
    }),
    style: getStyle({
      backgroundColor: backgroundColor,
      style: style,
      textColor: textColor
    })
  }, props, initials && {
    role: 'img'
  }, (imgSrc || initials) && {
    'aria-hidden': 'true'
  }), Boolean(initials) && initials, children);
};
Avatar.propTypes = process.env.NODE_ENV !== "production" ? {
  alt: _propTypes["default"].string,
  backgroundColor: _propTypes["default"].string,
  className: _propTypes["default"].string,
  children: _propTypes["default"].node,
  imgSrc: _propTypes["default"].string,
  initials: _propTypes["default"].string,
  size: _proptypes["default"],
  style: _propTypes["default"].object,
  textColor: _propTypes["default"].string
} : {};
Avatar.defaultProps = {
  size: 'large'
};
var _default = exports["default"] = Avatar;